import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { isBoolean } from 'lodash'
import css from './radio.css'

const Radio = ({ className, value, children, group, title, isChecked, onChange = () => {} }) => (
    <div className={`${css.inputGroup} ${className}`} title={title}>
        <input
            type="radio"
            className={css.radioInput}
            name={group}
            id={value}
            value={value}
            onChange={onChange}
            defaultChecked={isBoolean(isChecked) ? isChecked : null}
            required
        />
        <label className={css.label} htmlFor={value}>
            <div className={css.radio} />
            {children}
        </label>
    </div>
)

Radio.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string.isRequired,
    group: PropTypes.string.isRequired,
    children: PropTypes.node,
    title: PropTypes.string,
    isChecked: PropTypes.bool,
}

export default Radio
